var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonGuardianPushNotification = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M33.316 2H14.684C12.097 2 10 3.977 10 6.416v35.261c0 2.44 2.097 4.416 4.684 4.416h18.632c2.587 0 4.684-1.977 4.684-4.416V6.416C38 3.976 35.903 2 33.316 2z", fill: fills.light }),
        React.createElement("rect", { x: 18.117, y: 10.187, width: 22.647, height: 19.631, rx: 1.5, fill: fills.dark }),
        React.createElement("path", { d: "M18.112 34.144V26.45a.7.7 0 01.7-.7h7.694A.7.7 0 0127 26.945l-7.693 7.693a.7.7 0 01-1.195-.494zM24 42a1.995 1.995 0 110-3.992A1.995 1.995 0 1124 42z", fill: fills.dark }),
        React.createElement("path", { d: "M25.112 19.207c1.977-.326 3.527-1.963 3.852-3.944l.109-.951c.027-.152-.076-.362-.267-.347-1.494.116-2.903.61-3.688.931-.389.16-.642.538-.642.96v3.104a.3.3 0 00.346.295l.29-.047v-.001zM29.918 15.263c.325 1.98 1.875 3.618 3.851 3.944l.29.047c.182.03.347-.11.347-.295v-3.105c0-.421-.254-.8-.643-.959-.785-.322-2.194-.815-3.688-.931-.192-.016-.29.197-.268.346l.11.952v.001zM33.768 20.077c-2.702.533-3.957 2.332-3.957 5.738 0 .17.17.29.312.194 1.243-.84 3.977-3.03 4.259-5.771.01-.345-.42-.183-.614-.161zM25.113 20.077c2.702.533 3.956 2.332 3.956 5.738 0 .17-.169.29-.311.194-1.243-.84-3.977-3.03-4.259-5.771-.01-.345.42-.183.614-.161z", fill: "#fff" })));
}, {
    name: identiconComponentName,
})({});
